//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueCountryIntl from "vue-country-intl";
import "vue-country-intl/lib/vue-country-intl.css";
import AuthBottom from "../../components/AuthBottom.vue";
import { Checkbox } from "vant";
import {
  register,
  queryAgentBonus,
  queryRegisterItem,
  registerPhoneCode,
} from "@/common/api/system.js";
import { compare } from "@/common/utils/";
import { registerRF, checkDisparity } from "../../libs/rule-form.js";
import systemFormMx from "../mixins/system-form.js";
import { initAgentCode } from "@/common/utils/initRegisterAgentCode.js";

import { mapState, mapMutations } from "vuex";
import { getAgentDomain } from "@/common/api/normal.js";

export default {
  name: "Register",
  mixins: [systemFormMx],
  components: {
    AuthBottom,
    VueCountryIntl,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      ruleForm: {
        username: "",
        password: "",
        areaCode: "86",
        phone: "",
        vrifyCode: "",
        agentCode: "",
        timestamp: "",
      },
      rules: {
        username: [
          {
            required: true,
            pattern: /^[A-Za-z0-9]{6,12}$/,
            message: this.$i18n.t("register.usernamePlace"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            pattern: /^[A-Za-z0-9]{6,12}$/,
            message: this.$i18n.t("register.passwordPlace"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            validator: this.phoneValidator,
            message: this.$i18n.t("register.phoneTips"),
            trigger: "blur",
          },
        ],
        agentCode: [],
      },
      RegisterList: [
        // 表单动态项
        {
          lengthMin: 6,
          lengthMax: 12,
          requireSwitch: "1",
          sort: -2,
          typeName: "username",
        },
        {
          lengthMin: 6,
          lengthMax: 12,
          requireSwitch: "1",
          sort: -1,
          typeName: "password",
        },
        // {
        //   lengthMin: 6,
        //   lengthMax: 12,
        //   requireSwitch: "1",
        //   sort: 0,
        //   typeName: "repeatPassword",
        // },
        // {
        //   lengthMin: 0,
        //   lengthMax: 12,
        //   requireSwitch: "1",
        //   sort: 100,
        //   typeName: "vrifyCode",
        // },
        {
          lengthMin: 0,
          lengthMax: 12,
          requireSwitch: "0",
          sort: 99,
          typeName: "agentCode",
        },
      ],
      isAgree: false,
      activeIcon: require("../../assets/image/auth/active-icon.png"),
      inactiveIcon: require("../../assets/image/auth/inactive-icon.png"),

      bonusVisible: false,
      dialogIsShow: false,
      agentCodeRemain: "", //代理code

      isSendYzm: false, // 是否正在发送短信验证码
      countDownTime: 60, // 短信验证倒计时
      titleImg: "",
    };
  },
  computed: {
    customRegisterItem() {
      // 注册项是否显示
      let obj = {};
      if (this.RegisterList.length > 0) {
        this.RegisterList.forEach((item) => {
          if (item.typeName === "phoneNumber") item.typeName = "phone";
          obj[item.typeName] = {
            ...item,
            require: item.requireSwitch === "1" ? true : false,
            isShow: true,
          };
        });
      }
      return obj;
    },
    isPhoneCode() {
      // 是否发送短信验证码 1 是 0 否
      return this.$store.state.linkList.hasSendPhoneCode === "1";
    },
    ...mapState({
      regPhoneType: (state) => state.linkList.regPhoneType,
      showRegister: (state) => state.showRegister,
    }),
  },
  created() {
    // const checkPwdFn = checkDisparity({
    //   that: this,
    //   objName: "ruleForm",
    //   keyName1: "password",
    //   keyName2: "repeatPassword",
    // });

    initAgentCode(this); // 初始化 agentCode

    this.$set(this.ruleForm, "regDomain", document.domain);
    // this._getRegisterList();
    // this._getAgentDomain()
  },
  methods: {
    ...mapMutations(["SET_REGISTER", "SET_LOGIN_SHOW"]),
    //代理code
    _getAgentDomain() {
      getAgentDomain({}).then(([data, err]) => {
        if (!err) {
          this.ruleForm.agentCode = data;
          this.agentCodeRemain = data;
        }
      });
    },
    phoneValidator(rule, value, callback) {
      // 手机号验证
      let { areaCode } = this.ruleForm;
      if (areaCode === "86") {
        if (!/^1[3-9](\d{9})$/.test(value)) {
          return callback(new Error(this.$i18n.t("register.phoneTips")));
        }
      } else {
        if (!/^9\d{9}$/.test(value)) {
          return callback(new Error(this.$i18n.t("register.phoneTips")));
        }
      }

      callback(); // 验证通过
    },
    async _submit() {
      // 注册
      if (!this.isAgree) {
        this.$showToast({ text: this.$t("Forms.agreeTips"), type: "cancel" });
        return;
      }
      // if (this.isPhoneVerify === '3') this.$set(this.ruleForm, 'repeatPassword', this.ruleForm.password)
      this.$set(this.ruleForm, "repeatPassword", this.ruleForm.password);
      this.$set(this.ruleForm, "username", this.ruleForm.username);
      this.$set(this.ruleForm, "registerType", "1");
      this.submitLoading = true;
      const [data, err, res] = await register({
        ...this.ruleForm,
        regType: this.isPhoneCode ? "3" : "",
      });
      this.submitLoading = false;
      if (!err) {
        let UUID = res.data.data;
        this.$Cookies.set("UUID", UUID);
        let timer = setTimeout(() => {
          this.$store.dispatch("Login", UUID);
          this.$store.dispatch("refreshUserInfo", 1); // 登录时候获取用户信息
          this._queryAgentBonus();
          this.$store.commit("setRegisterAgentCode"); // 清除code
          clearTimeout(timer);
        }, 300);
      } else {
        this.$showToast({ text: res.data.msg, type: "cancel" });
        if (this.$refs.gVrifycodeEle) this.$refs.gVrifycodeEle.handleVifyCode();
      }
    },

    async _getRegisterList() {
      // 获取自定义注册列表
      this.$store.commit("setPageLoading", true);
      const [data, err] = await queryRegisterItem();
      this.$store.commit("setPageLoading", false);
      if (!err)
        this.RegisterList = [...this.RegisterList, ...data].sort(
          compare("sort", true)
        );
    },

    async _queryAgentBonus() {
      // 查询注册用户是否为代理注册
      const [data, err, res] = await queryAgentBonus({
        agentCode: this.ruleForm.agentCode,
      });
      if (!err) {
        this.bonusVisible = data.length > 0;
        this.dialogIsShow = data.length <= 0;
      } else {
        this.$router.replace({ path: "/" });
      }
    },

    handleJump(path) {
      // 跳转新页面
      if (this.bonusVisible) this.bonusVisible = false;
      if (this.dialogIsShow) this.dialogIsShow = false;
      if (path === "/") path = this.successPath + "";
      this.$router.replace({ path });
    },
    handleSendCode() {
      this.$set(
        this.ruleForm,
        "phone",
        this.ruleForm.phone.replace(/(^\s*)|(\s*$)/g, "")
      );
      this.$refs["ruleForm"].validateField("phone", (phoneError) => {
        // 验证手机号码是否正确
        if (!phoneError) {
          if (this.isSendYzm) return;
          this.isSendYzm = true;
          registerPhoneCode({ phoneNum: this.ruleForm.phone }).then(
            ([data, err, res]) => {
              if (!err) {
                // console.log(data)
              } else {
                this.$showToast({ text: res.data.msg, type: "warn" });
                this.countDownFinsh();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    countDownFinsh() {
      // 结束验证倒计时
      this.isSendYzm = false;
      this.countDownTime = 60;
    },

    handleAgree(v) {
      console.log(v);
      this.isAgree = v;
    },

    handleLogin() {
      // 登录
      this._close();
      let timer = setTimeout(() => {
        this.SET_LOGIN_SHOW();
        clearTimeout(timer);
      }, 200);
    },
    _close() {
      if (this.$store.state.showRegister) {
        // 弹框式打开
        let timer = setTimeout(() => {
          // this.ruleForm = clearObject(this.ruleForm)
          this.ruleForm = Object.assign({}, registerRF);
          this.changeLiveChat(true);
          this.SET_REGISTER(false);
          clearTimeout(timer);
        }, 1000);
      } else {
        this.ruleForm = Object.assign({}, registerRF);
        this.changeLiveChat(true);
        this.$router.replace({ path: "/home" });
      }
    },
  },
  mounted() {},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/register/index.vue